import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="container mt-4">
        <h1>{t("privacy.title")}</h1>
        <p>{t("privacy.intro")}</p>
        <h5>{t("privacy.cookiesUsed")}</h5>
        <ul>
          <li>{t("privacy.functional")}</li>
          <li>{t("privacy.analytics")}</li>
        </ul>
        <p>{t("privacy.control")}</p>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
